(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 41816:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ composeEventHandlers; }
/* harmony export */ });
function composeEventHandlers(e,n,{checkForDefaultPrevented:t=!0}={}){return function(r){if(null==e||e(r),!1===t||!r.defaultPrevented)return null==n?void 0:n(r)}}
//# sourceMappingURL=index.module.js.map


/***/ }),

/***/ 71206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "VY": function() { return /* binding */ Content; },
/* harmony export */   "fC": function() { return /* binding */ Root; },
/* harmony export */   "p_": function() { return /* binding */ d; },
/* harmony export */   "xz": function() { return /* binding */ Trigger; }
/* harmony export */ });
/* unused harmony exports Collapsible, CollapsibleTrigger, CollapsibleContent */
/* harmony import */ var _radix_ui_react_id__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26074);
/* harmony import */ var _radix_ui_react_presence__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28245);
/* harmony import */ var _radix_ui_react_primitive__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72130);
/* harmony import */ var _radix_ui_react_compose_refs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26215);
/* harmony import */ var _radix_ui_react_use_layout_effect__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(64680);
/* harmony import */ var _radix_ui_react_use_controllable_state__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73597);
/* harmony import */ var _radix_ui_react_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34540);
/* harmony import */ var _radix_ui_primitive__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41816);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7896);
const[p,d]=(0,_radix_ui_react_context__WEBPACK_IMPORTED_MODULE_1__/* .createContextScope */ .b)("Collapsible");const[u,m]=p("Collapsible");const Collapsible=/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(((t,n)=>{const{__scopeCollapsible:r,open:a,defaultOpen:l,disabled:p,onOpenChange:d,...m}=t,[f=!1,C]=(0,_radix_ui_react_use_controllable_state__WEBPACK_IMPORTED_MODULE_2__/* .useControllableState */ .T)({prop:a,defaultProp:l,onChange:d});/*#__PURE__*/return react__WEBPACK_IMPORTED_MODULE_0__.createElement(u,{scope:r,disabled:p,contentId:(0,_radix_ui_react_id__WEBPACK_IMPORTED_MODULE_3__/* .useId */ .M)(),open:f,onOpenToggle:react__WEBPACK_IMPORTED_MODULE_0__.useCallback((()=>C((e=>!e))),[C])},/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_radix_ui_react_primitive__WEBPACK_IMPORTED_MODULE_4__/* .Primitive.div */ .W.div,(0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({"data-state":b(f),"data-disabled":p?"":void 0},m,{ref:n})))}));/*#__PURE__*/const CollapsibleTrigger=/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(((e,t)=>{const{__scopeCollapsible:n,...r}=e,i=m("CollapsibleTrigger",n);/*#__PURE__*/return react__WEBPACK_IMPORTED_MODULE_0__.createElement(_radix_ui_react_primitive__WEBPACK_IMPORTED_MODULE_4__/* .Primitive.button */ .W.button,(0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({type:"button","aria-controls":i.contentId,"aria-expanded":i.open||!1,"data-state":b(i.open),"data-disabled":i.disabled?"":void 0,disabled:i.disabled},r,{ref:t,onClick:(0,_radix_ui_primitive__WEBPACK_IMPORTED_MODULE_6__/* .composeEventHandlers */ .M)(e.onClick,i.onOpenToggle)}))}));/*#__PURE__*/const CollapsibleContent=/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(((e,o)=>{const{forceMount:n,...r}=e,i=m("CollapsibleContent",e.__scopeCollapsible);/*#__PURE__*/return react__WEBPACK_IMPORTED_MODULE_0__.createElement(_radix_ui_react_presence__WEBPACK_IMPORTED_MODULE_7__/* .Presence */ .z,{present:n||i.open},(({present:e})=>/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(f,(0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({},r,{ref:o,present:e}))))}));/*#__PURE__*/const f=/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(((e,t)=>{const{__scopeCollapsible:i,present:a,children:l,...p}=e,d=m("CollapsibleContent",i),[u,f]=react__WEBPACK_IMPORTED_MODULE_0__.useState(a),C=react__WEBPACK_IMPORTED_MODULE_0__.useRef(null),x=(0,_radix_ui_react_compose_refs__WEBPACK_IMPORTED_MODULE_8__/* .useComposedRefs */ .e)(t,C),g=react__WEBPACK_IMPORTED_MODULE_0__.useRef(0),y=g.current,h=react__WEBPACK_IMPORTED_MODULE_0__.useRef(0),R=h.current,D=d.open||u,v=react__WEBPACK_IMPORTED_MODULE_0__.useRef(D),_=react__WEBPACK_IMPORTED_MODULE_0__.useRef();return react__WEBPACK_IMPORTED_MODULE_0__.useEffect((()=>{const e=requestAnimationFrame((()=>v.current=!1));return()=>cancelAnimationFrame(e)}),[]),(0,_radix_ui_react_use_layout_effect__WEBPACK_IMPORTED_MODULE_9__/* .useLayoutEffect */ .b)((()=>{const e=C.current;if(e){_.current=_.current||{transitionDuration:e.style.transitionDuration,animationDuration:e.style.animationDuration,animationFillMode:e.style.animationFillMode},e.style.transitionDuration="0s",e.style.animationDuration="0s",e.style.animationFillMode="none";const t=e.getBoundingClientRect();g.current=t.height,h.current=t.width,v.current||(e.style.transitionDuration=_.current.transitionDuration,e.style.animationDuration=_.current.animationDuration,e.style.animationFillMode=_.current.animationFillMode),f(a)}}),[d.open,a]),/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_radix_ui_react_primitive__WEBPACK_IMPORTED_MODULE_4__/* .Primitive.div */ .W.div,(0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({"data-state":b(d.open),"data-disabled":d.disabled?"":void 0,id:d.contentId,hidden:!D},p,{ref:x,style:{"--radix-collapsible-content-height":y?`${y}px`:void 0,"--radix-collapsible-content-width":R?`${R}px`:void 0,...e.style}}),D&&l)}));function b(e){return e?"open":"closed"}const Root=Collapsible;const Trigger=CollapsibleTrigger;const Content=CollapsibleContent;
//# sourceMappingURL=index.module.js.map


/***/ }),

/***/ 26215:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ composeRefs; },
/* harmony export */   "e": function() { return /* binding */ useComposedRefs; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
function composeRefs(...o){return e=>o.forEach((o=>function(o,e){"function"==typeof o?o(e):null!=o&&(o.current=e)}(o,e)))}function useComposedRefs(...e){return react__WEBPACK_IMPORTED_MODULE_0__.useCallback(composeRefs(...e),e)}
//# sourceMappingURL=index.module.js.map


/***/ }),

/***/ 34540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ createContextScope; },
/* harmony export */   "k": function() { return /* binding */ createContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
function createContext(t,n){const o=/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(n);function r(t){const{children:n,...r}=t,c=react__WEBPACK_IMPORTED_MODULE_0__.useMemo((()=>r),Object.values(r));/*#__PURE__*/return react__WEBPACK_IMPORTED_MODULE_0__.createElement(o.Provider,{value:c},n)}return r.displayName=t+"Provider",[r,function(r){const c=react__WEBPACK_IMPORTED_MODULE_0__.useContext(o);if(c)return c;if(void 0!==n)return n;throw new Error(`\`${r}\` must be used within \`${t}\``)}]}function createContextScope(n,o=[]){let r=[];const c=()=>{const t=r.map((t=>/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(t)));return function(o){const r=(null==o?void 0:o[n])||t;return react__WEBPACK_IMPORTED_MODULE_0__.useMemo((()=>({[`__scope${n}`]:{...o,[n]:r}})),[o,r])}};return c.scopeName=n,[function(t,o){const c=/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(o),u=r.length;function s(t){const{scope:o,children:r,...s}=t,i=(null==o?void 0:o[n][u])||c,a=react__WEBPACK_IMPORTED_MODULE_0__.useMemo((()=>s),Object.values(s));/*#__PURE__*/return react__WEBPACK_IMPORTED_MODULE_0__.createElement(i.Provider,{value:a},r)}return r=[...r,o],s.displayName=t+"Provider",[s,function(r,s){const i=(null==s?void 0:s[n][u])||c,a=react__WEBPACK_IMPORTED_MODULE_0__.useContext(i);if(a)return a;if(void 0!==o)return o;throw new Error(`\`${r}\` must be used within \`${t}\``)}]},t(c,...o)]}function t(...t){const n=t[0];if(1===t.length)return n;const o=()=>{const o=t.map((e=>({useScope:e(),scopeName:e.scopeName})));return function(t){const r=o.reduce(((e,{useScope:n,scopeName:o})=>({...e,...n(t)[`__scope${o}`]})),{});return react__WEBPACK_IMPORTED_MODULE_0__.useMemo((()=>({[`__scope${n.scopeName}`]:r})),[r])}};return o.scopeName=n.scopeName,o}
//# sourceMappingURL=index.module.js.map


/***/ }),

/***/ 26074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var react__WEBPACK_IMPORTED_MODULE_0___namespace_cache;
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ useId; }
/* harmony export */ });
/* unused harmony export IdProvider */
/* harmony import */ var _radix_ui_react_use_layout_effect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64680);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
const r=/*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))["useId".toString()]||(()=>{});let n=0;function useId(o){const[u,i]=react__WEBPACK_IMPORTED_MODULE_0__.useState(r());return (0,_radix_ui_react_use_layout_effect__WEBPACK_IMPORTED_MODULE_1__/* .useLayoutEffect */ .b)((()=>{o||i((t=>null!=t?t:String(n++)))}),[o]),o||(u?`radix-${u}`:"")}function IdProvider({children:t}){return e.useEffect((()=>{0}),[]),/*#__PURE__*/e.createElement(e.Fragment,null,t)}
//# sourceMappingURL=index.module.js.map


/***/ }),

/***/ 28245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ Presence; }
/* harmony export */ });
/* harmony import */ var _radix_ui_react_use_layout_effect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64680);
/* harmony import */ var _radix_ui_react_compose_refs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26215);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
const Presence=u=>{const{present:o,children:i}=u,s=function(n){const[u,o]=react__WEBPACK_IMPORTED_MODULE_0__.useState(),i=react__WEBPACK_IMPORTED_MODULE_0__.useRef({}),s=react__WEBPACK_IMPORTED_MODULE_0__.useRef(n),c=react__WEBPACK_IMPORTED_MODULE_0__.useRef("none"),a=n?"mounted":"unmounted",[d,m]=function(e,n){return react__WEBPACK_IMPORTED_MODULE_0__.useReducer(((e,t)=>{const r=n[e][t];return null!=r?r:e}),e)}(a,{mounted:{UNMOUNT:"unmounted",ANIMATION_OUT:"unmountSuspended"},unmountSuspended:{MOUNT:"mounted",ANIMATION_END:"unmounted"},unmounted:{MOUNT:"mounted"}});return react__WEBPACK_IMPORTED_MODULE_0__.useEffect((()=>{const e=r(i.current);c.current="mounted"===d?e:"none"}),[d]),(0,_radix_ui_react_use_layout_effect__WEBPACK_IMPORTED_MODULE_1__/* .useLayoutEffect */ .b)((()=>{const e=i.current,t=s.current;if(t!==n){const u=c.current,o=r(e);if(n)m("MOUNT");else if("none"===o||"none"===(null==e?void 0:e.display))m("UNMOUNT");else{const e=u!==o;m(t&&e?"ANIMATION_OUT":"UNMOUNT")}s.current=n}}),[n,m]),(0,_radix_ui_react_use_layout_effect__WEBPACK_IMPORTED_MODULE_1__/* .useLayoutEffect */ .b)((()=>{if(u){const e=e=>{const n=r(i.current).includes(e.animationName);e.target===u&&n&&m("ANIMATION_END")},n=e=>{e.target===u&&(c.current=r(i.current))};return u.addEventListener("animationstart",n),u.addEventListener("animationcancel",e),u.addEventListener("animationend",e),()=>{u.removeEventListener("animationstart",n),u.removeEventListener("animationcancel",e),u.removeEventListener("animationend",e)}}m("ANIMATION_END")}),[u,m]),{isPresent:["mounted","unmountSuspended"].includes(d),ref:react__WEBPACK_IMPORTED_MODULE_0__.useCallback((e=>{e&&(i.current=getComputedStyle(e)),o(e)}),[])}}(o),c="function"==typeof i?i({present:s.isPresent}):react__WEBPACK_IMPORTED_MODULE_0__.Children.only(i),a=(0,_radix_ui_react_compose_refs__WEBPACK_IMPORTED_MODULE_2__/* .useComposedRefs */ .e)(s.ref,c.ref);return"function"==typeof i||s.isPresent?/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(c,{ref:a}):null};function r(e){return(null==e?void 0:e.animationName)||"none"}Presence.displayName="Presence";
//# sourceMappingURL=index.module.js.map


/***/ }),

/***/ 72130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ Primitive; }
/* harmony export */ });
/* unused harmony export Root */
/* harmony import */ var _radix_ui_react_slot__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99575);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7896);
const Primitive=["a","button","div","h2","h3","img","li","nav","ol","p","span","svg","ul"].reduce(((o,i)=>({...o,[i]:/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(((o,m)=>{const{asChild:a,...s}=o,n=a?_radix_ui_react_slot__WEBPACK_IMPORTED_MODULE_1__/* .Slot */ .g7:i;return react__WEBPACK_IMPORTED_MODULE_0__.useEffect((()=>{window[Symbol.for("radix-ui")]=!0}),[]),/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(n,(0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({},s,{ref:m}))}))})),{});const Root=(/* unused pure expression or super */ null && (Primitive));
//# sourceMappingURL=index.module.js.map


/***/ }),

/***/ 99575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A4": function() { return /* binding */ Slottable; },
/* harmony export */   "g7": function() { return /* binding */ Slot; }
/* harmony export */ });
/* unused harmony export Root */
/* harmony import */ var _radix_ui_react_compose_refs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26215);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7896);
const Slot=/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(((e,o)=>{const{children:a,...s}=e;return react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(a).some(l)?/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,react__WEBPACK_IMPORTED_MODULE_0__.Children.map(a,(e=>l(e)?/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(n,(0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({},s,{ref:o}),e.props.children):e))):/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(n,(0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({},s,{ref:o}),a)}));Slot.displayName="Slot";const n=/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(((r,n)=>{const{children:l,...a}=r;/*#__PURE__*/return react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(l)?/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(l,{...o(a,l.props),ref:(0,_radix_ui_react_compose_refs__WEBPACK_IMPORTED_MODULE_2__/* .composeRefs */ .F)(n,l.ref)}):react__WEBPACK_IMPORTED_MODULE_0__.Children.count(l)>1?react__WEBPACK_IMPORTED_MODULE_0__.Children.only(null):null}));n.displayName="SlotClone";const Slottable=({children:e})=>/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment,null,e);function l(e){/*#__PURE__*/return react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(e)&&e.type===Slottable}function o(e,t){const r={...t};for(const n in t){const l=e[n],o=t[n];/^on[A-Z]/.test(n)?r[n]=(...e)=>{null==o||o(...e),null==l||l(...e)}:"style"===n?r[n]={...l,...o}:"className"===n&&(r[n]=[l,o].filter(Boolean).join(" "))}return{...e,...r}}const Root=(/* unused pure expression or super */ null && (Slot));
//# sourceMappingURL=index.module.js.map


/***/ }),

/***/ 86029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ useCallbackRef; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
function useCallbackRef(r){const t=react__WEBPACK_IMPORTED_MODULE_0__.useRef(r);return react__WEBPACK_IMPORTED_MODULE_0__.useEffect((()=>{t.current=r})),react__WEBPACK_IMPORTED_MODULE_0__.useMemo((()=>(...e)=>{var r;return null===(r=t.current)||void 0===r?void 0:r.call(t,...e)}),[])}
//# sourceMappingURL=index.module.js.map


/***/ }),

/***/ 73597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ useControllableState; }
/* harmony export */ });
/* harmony import */ var _radix_ui_react_use_callback_ref__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86029);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
function useControllableState({prop:o,defaultProp:r,onChange:n=(()=>{})}){const[a,u]=function({defaultProp:o,onChange:r}){const n=react__WEBPACK_IMPORTED_MODULE_0__.useState(o),[a]=n,u=react__WEBPACK_IMPORTED_MODULE_0__.useRef(a),c=(0,_radix_ui_react_use_callback_ref__WEBPACK_IMPORTED_MODULE_1__/* .useCallbackRef */ .W)(r);return react__WEBPACK_IMPORTED_MODULE_0__.useEffect((()=>{u.current!==a&&(c(a),u.current=a)}),[a,u,c]),n}({defaultProp:r,onChange:n}),c=void 0!==o,f=c?o:a,l=(0,_radix_ui_react_use_callback_ref__WEBPACK_IMPORTED_MODULE_1__/* .useCallbackRef */ .W)(n);return[f,react__WEBPACK_IMPORTED_MODULE_0__.useCallback((e=>{if(c){const t=e,r="function"==typeof e?t(o):e;r!==o&&l(r)}else u(e)}),[c,o,u,l])]}
//# sourceMappingURL=index.module.js.map


/***/ }),

/***/ 64680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ useLayoutEffect; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
const useLayoutEffect=Boolean(null===globalThis||void 0===globalThis?void 0:globalThis.document)?react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect:()=>{};
//# sourceMappingURL=index.module.js.map


/***/ }),

/***/ 14160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _style, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgCash = function SvgCash(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    id: "cash_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 550.35 550.35",
    style: {
      enableBackground: "new 0 0 550.35 550.35"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("style", null, ".cash_svg__st1{fill:#00ff52;stroke:#000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    cx: 275.17,
    cy: 275.17,
    r: 275.17,
    style: {
      fill: "#e5e5e5"
    }
  }), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    transform: "rotate(-39.649 226.673 255.199)",
    className: "cash_svg__st1",
    d: "M86.12 171.9h281.16v166.64H86.12z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    transform: "rotate(-32.552 269.777 274.226)",
    className: "cash_svg__st1",
    d: "M129.2 190.92h281.16v166.64H129.2z"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    transform: "rotate(-22.256 314.72 307.4)",
    className: "cash_svg__st1",
    d: "M174.09 224.07h281.16v166.64H174.09z"
  })), _path4 || (_path4 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M296.66 260.13c3.49-1.43 7.39.21 8.82 3.7l.69 1.68c6.89-1.7 13.45-2.14 19.81-1.37 2.83.39 5.81 1.84 7.29 5.44 1.87 4.57-.31 9.54-4.88 11.41-1.44.59-3.03.82-4.65.64-4.11-.43-8.07-.49-11.66 0l7.49 18.29c20.31-2.55 31.18 1.71 36.7 15.18 5.52 13.48-1.28 26.37-15.75 34.26l2.61 6.38a6.72 6.72 0 0 1-3.69 8.82c-3.49 1.43-7.39-.21-8.82-3.7l-2.66-6.5c-8.99 2.41-18.28 2.7-27.15 1.28-3.17-.53-5.72-2.3-7.05-5.54-1.92-4.69.26-9.66 4.95-11.58 1.56-.64 3.49-.73 5.33-.36 6.38 1.18 12.13 1.5 18.16.43l-7.83-19.13c-19.25 2.4-30.5-.72-36.36-15.04-5.42-13.23 1.04-26.27 15.56-34.04l-.59-1.44c-1.45-3.48.19-7.38 3.68-8.81zm10.3 41.3-6.65-16.24c-5.43 3.21-6.78 7.13-5.2 10.98 1.53 3.73 4.24 5.56 11.85 5.26zm19.93 16.43 6.85 16.72c5.31-3.16 7.11-6.99 5.34-11.32-1.63-3.97-4.76-5.78-12.19-5.4z"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgCash);

/***/ }),

/***/ 96382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _style, _circle, _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgLightbulb = function SvgLightbulb(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    id: "lightbulb_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 550.35 550.35",
    style: {
      enableBackground: "new 0 0 550.35 550.35"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("style", null, ".lightbulb_svg__st1{fill:#00ff52}")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    cx: 275.17,
    cy: 275.17,
    r: 275.17,
    style: {
      fill: "#e5e5e5"
    }
  }), _circle || (_circle = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    className: "lightbulb_svg__st1",
    cx: 275.17,
    cy: 216.74,
    r: 132.15
  })), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M275.17 358.89c-78.38 0-142.15-63.77-142.15-142.15S196.79 74.59 275.17 74.59s142.15 63.77 142.15 142.15-63.77 142.15-142.15 142.15zm0-264.29c-67.35 0-122.15 54.8-122.15 122.15S207.81 338.9 275.17 338.9s122.15-54.79 122.15-122.15S342.53 94.6 275.17 94.6z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    className: "lightbulb_svg__st1",
    d: "M299.02 471.75h-47.68c-21.71 0-39.31-17.6-39.31-39.31v-96.48h126.3v96.48c-.01 21.71-17.61 39.31-39.31 39.31z"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M299.01 481.75h-47.68c-27.19 0-49.31-22.12-49.31-49.31v-96.48c0-5.52 4.48-10 10-10h126.3c5.52 0 10 4.48 10 10v96.48c0 27.19-22.12 49.31-49.31 49.31zm-76.98-135.78v86.48c0 16.16 13.15 29.31 29.31 29.31h47.68c16.16 0 29.31-13.15 29.31-29.31v-86.48h-106.3z"
  })), _path4 || (_path4 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M326.9 388.51H217.22c-5.52 0-10-4.48-10-10s4.48-10 10-10H326.9c5.52 0 10 4.48 10 10s-4.47 10-10 10zM326.9 427.1H217.22c-5.52 0-10-4.48-10-10s4.48-10 10-10H326.9c5.52 0 10 4.48 10 10s-4.47 10-10 10zM333.92 204.33h-47.45c-5.52 0-10-4.48-10-10s4.48-10 10-10h47.45c5.52 0 10 4.48 10 10s-4.48 10-10 10z"
  })), _path5 || (_path5 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M333.92 204.33c-3.56 0-6.94-1.91-8.74-5.14-1.07-1.89-27.16-46.84-77.13-31.16-5.27 1.65-10.88-1.28-12.53-6.55-1.65-5.27 1.28-10.88 6.55-12.53 34.37-10.78 60 .89 75.45 12.59 2.29 1.73 4.42 3.51 6.4 5.3v-19.95c0-5.52 4.48-10 10-10s10 4.48 10 10v47.45c0 4.56-3.08 8.53-7.49 9.68-.84.21-1.68.31-2.51.31zM263.88 244.4h-47.45c-5.52 0-10-4.48-10-10s4.48-10 10-10h47.45c5.52 0 10 4.48 10 10s-4.48 10-10 10z"
  })), _path6 || (_path6 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M216.43 291.85c-5.52 0-10-4.48-10-10V234.4a10.003 10.003 0 0 1 18.74-4.87c1.07 1.89 27.16 46.84 77.13 31.16 5.27-1.65 10.88 1.28 12.53 6.55 1.65 5.27-1.28 10.88-6.55 12.53-34.36 10.78-60-.89-75.45-12.59a94.371 94.371 0 0 1-6.4-5.3v19.95c0 5.54-4.48 10.02-10 10.02z"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgLightbulb);

/***/ }),

/***/ 56290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgPlanet = function SvgPlanet(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 550.35 550.35",
    style: {
      enableBackground: "new 0 0 550.35 550.35"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    cx: 275.17,
    cy: 275.17,
    r: 275.17,
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    cx: 275.17,
    cy: 275.17,
    r: 166.73,
    style: {
      fill: "#00ff52"
    }
  }), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M275.17 451.91c-97.45 0-176.73-79.28-176.73-176.73 0-97.45 79.28-176.73 176.73-176.73S451.9 177.73 451.9 275.18c.01 97.44-79.28 176.73-176.73 176.73zm0-333.47c-86.42 0-156.73 70.31-156.73 156.73S188.75 431.9 275.17 431.9c86.42 0 156.73-70.31 156.73-156.73s-70.3-156.73-156.73-156.73z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M321.4 445.23c-2.66 0-6.47-.67-10.51-3.55-8.95-6.38-14.26-20.22-16.25-42.33-2.27-25.25 19.83-40.4 41.2-55.04 20.26-13.88 39.4-27 39.4-46.93 0-19.46-18.68-33.61-36.74-47.29-20.07-15.2-42.81-32.42-32.24-57.95 5.76-13.93 22.59-28.67 70-19.83 25.39 4.74 48.44 13.99 49.4 14.38 5.12 2.07 7.59 7.9 5.52 13.02-2.07 5.12-7.9 7.59-13.02 5.52-.22-.09-22.37-8.97-45.82-13.31-15.39-2.85-42.04-5.62-47.61 7.86-4.2 10.15 5.11 18.66 25.84 34.36 19.9 15.07 44.67 33.83 44.67 63.23 0 30.47-25.55 47.98-48.09 63.43-18.14 12.43-33.81 23.17-32.59 36.75 1.85 20.61 6.4 26.37 7.67 27.6h.05c4.49 0 8.57 3.05 9.7 7.6 1.33 5.36-1.95 10.78-7.31 12.11-.6.14-1.75.37-3.27.37zm-1.52-19.79h-.02.02zM125.66 297.72c-12.43 0-22.4-6.94-26.67-19.28-1.81-5.22.96-10.91 6.18-12.72 5.22-1.81 10.91.96 12.72 6.18.82 2.36 2.74 7.9 12.77 5.06 12.65-3.58 29.39-19.79 25.78-36.06-2.13-9.61-1.26-23.48 14.99-34.98 9.7-6.86 22.52-11.55 36.1-16.51 13.93-5.09 28.34-10.35 37.42-17.64 3.66-2.93 5.46-6.27 5.67-10.52.71-14.55-16.51-34.82-22.61-40.77-3.95-3.86-4.02-10.19-.16-14.14 3.86-3.95 10.19-4.02 14.14-.16 3.06 2.99 29.88 29.99 28.6 56.06-.49 9.95-5.03 18.64-13.13 25.14-11.65 9.34-27.62 15.17-43.07 20.82-28.12 10.27-41.07 16.42-38.42 28.37 2.83 12.76-.6 26.37-9.67 38.31-7.74 10.19-19.03 18.17-30.19 21.33-3.62 1.02-7.12 1.51-10.45 1.51zM225.72 387.09c-12.61 0-25.69-5.13-34.04-14.83-6.52-7.57-9.06-17.08-7.14-26.78 1.77-8.93 7.18-17.82 16.12-26.46-.13-3.58-.17-8.69.25-14.14 1.23-15.72 5.57-25.85 13.27-30.99 4.84-3.22 13.05-5.77 24.71.4 15.58 8.24 26.36 26.56 28.83 49 2.53 22.96-4.07 44.19-17.21 55.39-6.67 5.68-15.6 8.41-24.79 8.41zm-.32-96.55c-.08 0-.14.01-.18.01-3.07 1.76-5.72 16.75-4.35 31.72.29 3.2-.97 6.35-3.39 8.46-17.5 15.22-14.18 24.38-10.65 28.48 7.06 8.2 23.42 10.47 30.7 4.26 7.92-6.75 12.06-22.02 10.3-37.98-1.72-15.61-8.73-28.45-18.3-33.52-2.24-1.19-3.61-1.43-4.13-1.43z"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgPlanet);

/***/ }),

/***/ 40961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _style, _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgStars = function SvgStars(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    id: "stars_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 550.35 550.35",
    style: {
      enableBackground: "new 0 0 550.35 550.35"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("style", null, ".stars_svg__st1{fill:#00ff52}")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    cx: 275.17,
    cy: 275.17,
    r: 275.17,
    style: {
      fill: "#e5e5e5"
    }
  }), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    className: "stars_svg__st1",
    d: "m283.6 94.99 29.23 59.23 65.37 9.5-47.3 46.11 11.16 65.1-58.46-30.74-58.47 30.74 11.17-65.1-47.3-46.11 65.37-9.5z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M225.14 284.93c-2.07 0-4.14-.64-5.88-1.91a10.01 10.01 0 0 1-3.98-9.78l10.28-59.92-43.53-42.44c-2.73-2.66-3.71-6.63-2.53-10.25s4.31-6.26 8.07-6.81l60.16-8.74 26.91-54.52c1.68-3.41 5.16-5.57 8.97-5.57s7.28 2.16 8.97 5.57l26.91 54.52 60.16 8.74c3.77.55 6.9 3.19 8.07 6.81 1.18 3.62.2 7.59-2.53 10.25l-43.53 42.44 10.28 59.92c.64 3.75-.9 7.54-3.98 9.78a9.995 9.995 0 0 1-10.53.76l-53.81-28.29-53.81 28.29c-1.48.77-3.08 1.15-4.67 1.15zm58.46-50.74c1.6 0 3.2.38 4.65 1.15l40.53 21.31-7.74-45.13c-.56-3.24.52-6.55 2.88-8.85l32.79-31.96-45.31-6.58a9.997 9.997 0 0 1-7.53-5.47l-20.26-41.06-20.26 41.06c-1.46 2.95-4.27 5-7.53 5.47l-45.31 6.58 32.79 31.96c2.36 2.3 3.43 5.61 2.88 8.85l-7.74 45.13 40.53-21.31a9.772 9.772 0 0 1 4.63-1.15z"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    className: "stars_svg__st1",
    d: "m380.16 277.98 18.2 36.89 40.71 5.92-29.45 28.71 6.95 40.55-36.41-19.15-36.42 19.15 6.96-40.55-29.46-28.71 40.71-5.92z"
  })), _path4 || (_path4 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M416.57 400.05c-1.59 0-3.19-.38-4.65-1.15l-31.76-16.7-31.76 16.7a9.995 9.995 0 0 1-10.53-.76 10.01 10.01 0 0 1-3.98-9.78l6.07-35.36-25.69-25.04a9.983 9.983 0 0 1-2.53-10.25 10.02 10.02 0 0 1 8.07-6.81l35.51-5.16 15.88-32.18a9.997 9.997 0 0 1 8.97-5.57c3.81 0 7.28 2.16 8.97 5.57L405 305.73l35.51 5.16c3.77.55 6.9 3.19 8.07 6.81 1.18 3.62.2 7.59-2.53 10.25l-25.69 25.04 6.07 35.36c.64 3.75-.9 7.54-3.98 9.78a9.982 9.982 0 0 1-5.88 1.92zm-73.84-72.28 14.95 14.57c2.36 2.3 3.43 5.61 2.88 8.85l-3.53 20.58 18.48-9.71c2.91-1.53 6.39-1.53 9.31 0l18.48 9.71-3.53-20.58c-.56-3.24.52-6.55 2.88-8.85l14.95-14.57-20.66-3a9.997 9.997 0 0 1-7.53-5.47l-9.24-18.72-9.24 18.72c-1.46 2.95-4.27 5-7.53 5.47l-20.67 3z"
  })), _path5 || (_path5 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    className: "stars_svg__st1",
    d: "m181.32 266.18 25.35 51.37 56.69 8.24-41.02 39.99 9.68 56.46-50.7-26.66-50.71 26.66 9.69-56.46-41.03-39.99 56.69-8.24z"
  })), _path6 || (_path6 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M232.02 432.24c-1.59 0-3.19-.38-4.65-1.15l-46.05-24.21-46.05 24.21a9.995 9.995 0 0 1-10.53-.76 10.01 10.01 0 0 1-3.98-9.78l8.79-51.28-37.26-36.32c-2.73-2.66-3.71-6.63-2.53-10.25s4.31-6.26 8.07-6.81l51.49-7.48 23.03-46.66c1.68-3.41 5.16-5.57 8.97-5.57s7.28 2.16 8.97 5.57l23.03 46.66 51.49 7.48a10.004 10.004 0 0 1 5.54 17.06l-37.26 36.32 8.79 51.28c.64 3.75-.9 7.54-3.98 9.78a10.041 10.041 0 0 1-5.88 1.91zm-111.26-99.47 26.51 25.84c2.36 2.3 3.43 5.61 2.88 8.85l-6.26 36.49 32.77-17.23c2.91-1.53 6.39-1.53 9.31 0l32.77 17.23-6.26-36.49c-.56-3.24.52-6.55 2.88-8.85l26.51-25.84-36.64-5.32a9.997 9.997 0 0 1-7.53-5.47l-16.39-33.2-16.39 33.2c-1.46 2.95-4.27 5-7.53 5.47l-36.63 5.32z"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgStars);

/***/ }),

/***/ 88:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _style, _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgWaste = function SvgWaste(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    id: "waste_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 550.35 550.35",
    style: {
      enableBackground: "new 0 0 550.35 550.35"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("style", null, ".waste_svg__st1{fill:#00ff52}")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
    cx: 275.17,
    cy: 275.17,
    r: 275.17,
    style: {
      fill: "#e5e5e5"
    }
  }), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    className: "waste_svg__st1",
    d: "M144.4 215.09h261.54v45.09H144.4z"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M405.94 270.18H144.4c-5.52 0-10-4.48-10-10v-45.09c0-5.52 4.48-10 10-10h261.54c5.52 0 10 4.48 10 10v45.09c0 5.53-4.47 10-10 10zm-251.54-20h241.54v-25.09H154.4v25.09z"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    className: "waste_svg__st1",
    d: "M361.8 448.94H188.55l-25.79-187.87h224.83z"
  })), _path4 || (_path4 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M361.8 458.94H188.55c-5 0-9.23-3.69-9.91-8.64l-25.79-187.86a10.002 10.002 0 0 1 9.91-11.36h224.82a10.002 10.002 0 0 1 9.91 11.36L371.71 450.3a10.01 10.01 0 0 1-9.91 8.64zm-164.53-20h155.81l23.04-167.86H174.23l23.04 167.86z"
  })), _path5 || (_path5 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M228.21 423.01c-5.52 0-10-4.48-10-10V297c0-5.52 4.48-10 10-10s10 4.48 10 10v116.01c0 5.53-4.48 10-10 10zM275.17 423.01c-5.52 0-10-4.48-10-10V297c0-5.52 4.48-10 10-10s10 4.48 10 10v116.01c0 5.53-4.47 10-10 10zM322.14 423.01c-5.52 0-10-4.48-10-10V297c0-5.52 4.48-10 10-10s10 4.48 10 10v116.01c0 5.53-4.48 10-10 10zM314.96 178.2c-2.56 0-5.12-.98-7.07-2.93l-79.56-79.56c-3.9-3.91-3.9-10.24 0-14.14 3.91-3.91 10.24-3.91 14.14 0l79.56 79.56c3.91 3.91 3.91 10.24 0 14.14a9.99 9.99 0 0 1-7.07 2.93z"
  })), _path6 || (_path6 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M235.39 178.2c-2.56 0-5.12-.98-7.07-2.93-3.9-3.91-3.9-10.24 0-14.14l79.56-79.56c3.91-3.91 10.24-3.91 14.14 0 3.91 3.91 3.91 10.24 0 14.14l-79.56 79.56a9.973 9.973 0 0 1-7.07 2.93z"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgWaste);

/***/ }),

/***/ 87314:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(91918);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 96959:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/list-an-item-dt.d0526937.webp","height":300,"width":1170,"blurDataURL":"data:image/webp;base64,UklGRkgAAABXRUJQVlA4IDwAAACwAQCdASoIAAIAAkA4JagCdADdBGQwAP710e66QrUteST+ICLglkWIoaBWub85+h7/9tMb+Yf7Z1+saAA="});

/***/ }),

/***/ 90865:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/list-an-item-m.eb09f40c.webp","height":315,"width":340,"blurDataURL":"data:image/webp;base64,UklGRmoAAABXRUJQVlA4IF4AAADwAQCdASoIAAcAAkA4JbACdLoAArdwm4AAzdm+etQCVL1jl2TRFe7UXL/zCR6R83OjiraRSTa2qIn90p9LcFVvQ+6K5rDCH/qky9bw7CbkR3oZZ3+CH7ZeJ/6l3AAA"});

/***/ }),

/***/ 59832:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ useNewsletterDialog; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

var STORAGE_KEY = "releaseit-newsletter-seen";
var DELAY = 5 * 1000;
function useNewsletterDialog() {
    var hasSeenDialog = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(function() {
        // Localstorage not available in SSR
        if (false) {}
        return (localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem(STORAGE_KEY)) === "true";
    }, []);
    var ref = _slicedToArray(react__WEBPACK_IMPORTED_MODULE_0__.useState(false), 2), isShowing = ref[0], setIsShowing = ref[1];
    // Show the dialog after delay
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function() {
        var timeout = setTimeout(function() {
            setIsShowing(true);
            localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem(STORAGE_KEY, "true");
        }, DELAY);
        return function() {
            return clearTimeout(timeout);
        };
    }, []);
    var close = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function() {
        setIsShowing(false);
    }, []);
    return {
        hasSeenDialog: hasSeenDialog,
        isShowing: isShowing,
        close: close
    };
}


/***/ }),

/***/ 91918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react-error-boundary/dist/react-error-boundary.umd.js
var react_error_boundary_umd = __webpack_require__(80589);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/Seo.tsx
var Seo = __webpack_require__(68661);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../packages/ui/src/carousel/Carousel.tsx + 1 modules
var Carousel = __webpack_require__(88206);
// EXTERNAL MODULE: ./src/utils/analytics.tsx + 4 modules
var analytics = __webpack_require__(63642);
;// CONCATENATED MODULE: ./src/features/content/components/banner-carousel/BannerCarousel.tsx

/* eslint-disable jsx-a11y/no-static-element-interactions */ 



var AUTOPLAY_DURATION_MS = 5000;
// TODO: figure out how to use srcset with next/image
function BannerCarousel(param) {
    var images = param.images;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopCarousel, {
                images: images
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileCarousel, {
                images: images
            })
        ]
    });
}
function DesktopCarousel(param) {
    var images = param.images;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel/* Carousel */.l, {
        autoplay: {
            playOnInit: true,
            delay: AUTOPLAY_DURATION_MS
        },
        classNames: {
            carousel: "hidden md:block max-w-[1840px] mx-auto w-full",
            prevButton: "left-10",
            nextButton: "right-10"
        },
        children: images.map(function(image, idx) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: image.href,
                prefetch: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    onClick: function() {
                        return analytics/* analytics.trackEvent */.co.trackEvent("home.carousel", {
                            href: image.href,
                            desktop: image.desktop
                        });
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: image.desktop,
                        alt: "promo banner ".concat(idx, " desktop"),
                        layout: "responsive",
                        priority: idx === 0,
                        placeholder: "blur",
                        unoptimized: true,
                        objectFit: "cover"
                    })
                })
            }, image.href);
        })
    });
}
function MobileCarousel(param) {
    var images = param.images;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel/* Carousel */.l, {
        autoplay: {
            playOnInit: true,
            delay: AUTOPLAY_DURATION_MS
        },
        classNames: {
            carousel: "block md:hidden",
            prevButton: "left-10",
            nextButton: "right-10"
        },
        children: images.map(function(image, idx) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: image.href,
                prefetch: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    onClick: function() {
                        return analytics/* analytics.trackEvent */.co.trackEvent("home.carousel", {
                            href: image.href,
                            mobile: image.mobile
                        });
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: image.mobile,
                        alt: "promo banner ".concat(idx, " mobile"),
                        layout: "responsive",
                        priority: idx === 0,
                        placeholder: "blur",
                        unoptimized: true,
                        objectFit: "cover"
                    })
                })
            }, image.href);
        })
    });
}

;// CONCATENATED MODULE: ./src/features/content/components/value-props/ValueProps.tsx

/* eslint-disable global-require */ 
var VALUE_PROPS = [
    {
        icon: (__webpack_require__(96382)/* ["default"] */ .Z),
        text: "Rethink consumerism"
    },
    {
        icon: (__webpack_require__(88)/* ["default"] */ .Z),
        text: "Do more, waste less"
    },
    {
        icon: (__webpack_require__(56290)/* ["default"] */ .Z),
        text: "Protect the planet"
    },
    {
        icon: (__webpack_require__(40961)/* ["default"] */ .Z),
        text: "Experience everything"
    },
    {
        icon: (__webpack_require__(14160)/* ["default"] */ .Z),
        text: "Earn some extra cash"
    }, 
];
function ValueProps() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel/* Carousel */.l, {
        options: {
            draggable: false
        },
        autoplay: {
            playOnInit: true,
            delay: 3000,
            stopOnMouseEnter: false
        },
        className: " [--space-between:20px] md:[--slides-per-view:3] lg:[--slides-per-view:5] ",
        classNames: {
            carousel: "container",
            buttons: "md:hidden"
        },
        children: VALUE_PROPS.map(function(valueProp) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center justify-center gap-4 py-8 px-8 md:flex-col md:px-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(valueProp.icon, {
                        className: "h-10 w-10"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-base font-medium",
                        children: valueProp.text
                    })
                ]
            }, valueProp.text);
        })
    });
}

;// CONCATENATED MODULE: ./src/features/content/components/blocks/HeroBlock.tsx



function HeroBlock(param) {
    var bannerImages = param.bannerImages;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerCarousel, {
                images: bannerImages
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ValueProps, {})
        ]
    });
}

;// CONCATENATED MODULE: ./src/features/content/components/blocks/FeaturedInBlock.tsx


function FeaturedInBlock(param) {
    var logos = param.logos;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "container mt-4 lg:mt-6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "text-center text-2xl font-medium",
                children: "As featured in..."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mx-auto mt-4 flex flex-wrap justify-center gap-2 md:flex-nowrap",
                children: logos.map(function(logo) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: logo.href,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        className: "relative h-14 w-28 md:h-20 md:w-36 lg:h-24 lg:w-40",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: logo.image,
                            alt: logo.label,
                            layout: "fill",
                            objectFit: "contain"
                        })
                    }, logo.label);
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ../../packages/ui/src/collapsible/Collapsible.tsx
var Collapsible = __webpack_require__(46348);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./src/features/content/assets/icons/owners.svg
var _style, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgOwners = function SvgOwners(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    id: "owners_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 646.59 646.59",
    style: {
      enableBackground: "new 0 0 646.59 646.59"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/react.createElement("style", null, ".owners_svg__st1{fill:#00ff52}")), /*#__PURE__*/react.createElement("circle", {
    cx: 323.29,
    cy: 323.29,
    r: 323.29,
    style: {
      fill: "#262b33"
    }
  }), _path || (_path = /*#__PURE__*/react.createElement("path", {
    className: "owners_svg__st1",
    d: "M386.14 406.69h-50.13c-30.54 0-52.19-22.92-53.09-23.9-3.76-4.04-3.53-10.37.52-14.13 4.05-3.76 10.37-3.53 14.13.52.14.15 16.77 17.51 38.44 17.51h50.13c15.67 0 27.05-9.08 27.05-21.6 0-12.72-11.4-22.69-25.96-22.69-26.85 0-41.33-3.24-67.34-15.06-6.91-3.14-13.38-7.33-20.23-11.76-18.46-11.95-39.38-25.48-79.16-25.48-21.75 0-53.06 12.29-90.53 35.55-28.96 17.97-51.2 36.11-51.42 36.29-4.27 3.5-10.57 2.87-14.07-1.4s-2.87-10.57 1.4-14.07c3.81-3.12 93.99-76.36 154.62-76.36 45.69 0 70.27 15.91 90.02 28.69 6.48 4.19 12.08 7.82 17.64 10.34 23.47 10.67 35.06 13.27 59.07 13.27 25.77 0 45.96 18.75 45.96 42.69 0 23.71-20.22 41.59-47.05 41.59z"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    className: "owners_svg__st1",
    d: "M345.82 497.14c-20.21 0-48.64-15.69-76.12-30.86-20.98-11.58-44.77-24.71-55.74-24.71-21 0-69.55 25.7-86.49 35.61-4.77 2.79-10.89 1.18-13.68-3.58-2.79-4.77-1.19-10.89 3.58-13.68 6.71-3.92 66.42-38.34 96.59-38.34 16.12 0 38.96 12.61 65.4 27.2 24.09 13.3 51.4 28.37 66.46 28.37 4.83 0 23.13-4.65 88.65-47.69 40.24-26.43 82.56-57.03 102.89-71.74 5.89-4.26 10.15-7.34 12.27-8.81 8.14-5.65 13.12-12.55 14.4-19.95.99-5.68-.31-11.54-3.55-16.08-6.57-9.21-21.97-13.62-40.25-1.55-15.4 10.18-90.66 61.52-91.42 62.03-4.56 3.11-10.78 1.94-13.9-2.62-3.11-4.56-1.94-10.78 2.62-13.9 3.1-2.12 76.14-51.94 91.66-62.2 28.04-18.52 55.21-10.69 67.56 6.62 6.33 8.87 8.87 20.22 6.97 31.12-1.55 8.92-6.75 21.87-22.7 32.95-1.97 1.37-6.16 4.4-11.96 8.59-20.46 14.79-63.02 45.57-103.63 72.25-77.58 50.97-93.58 50.97-99.61 50.97z"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    className: "owners_svg__st1",
    d: "M399.04 341.63c-3.17 0-6.28-1.5-8.22-4.29-3.15-4.54-2.03-10.77 2.5-13.92.57-.4 57.43-39.92 68.17-47.64 7.5-5.39 16.54-8.42 25.44-8.54 10.67-.15 20.4 3.83 28.06 11.49 9.15 9.15 12.51 15.88 10.91 21.85-1.44 5.33-6.93 8.49-12.26 7.05a10.016 10.016 0 0 1-7.31-8.27c-.5-.84-1.91-2.91-5.48-6.49-9.53-9.53-21.89-5.02-27.69-.86-10.87 7.81-66.08 46.19-68.43 47.82a9.883 9.883 0 0 1-5.69 1.8zm107.54-46.22zm.01-.03v.01c-.01 0-.01 0 0-.01z"
  })), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
    className: "owners_svg__st1",
    d: "M340.41 331.72c-3.17 0-6.28-1.5-8.22-4.29-3.15-4.54-2.03-10.77 2.5-13.92.57-.4 57.43-39.92 68.17-47.64 7.5-5.39 16.54-8.42 25.44-8.54 10.67-.14 20.4 3.83 28.06 11.49 9.15 9.15 12.51 15.88 10.91 21.84-1.43 5.33-6.92 8.5-12.25 7.06-3.99-1.07-6.77-4.42-7.31-8.27-.5-.84-1.91-2.91-5.49-6.49-9.53-9.53-21.89-5.02-27.69-.86-10.87 7.81-66.08 46.19-68.43 47.82a9.837 9.837 0 0 1-5.69 1.8zm107.54-46.22c0 .01 0 .01 0 0 0 .01 0 .01 0 0zm.01-.02v.01-.01zM375.88 224.37a9.99 9.99 0 0 1-7.7-3.61l-43.8-52.68-46.14 52.86c-3.63 4.16-9.95 4.59-14.11.96s-4.59-9.95-.96-14.11l53.86-61.71c1.93-2.21 4.74-3.45 7.65-3.42 2.93.04 5.7 1.35 7.57 3.61l51.3 61.71c3.53 4.25 2.95 10.55-1.3 14.08a9.846 9.846 0 0 1-6.37 2.31z"
  })));
};

/* harmony default export */ var owners = (SvgOwners);
;// CONCATENATED MODULE: ./src/features/content/assets/icons/seekers.svg
var seekers_style, seekers_path, seekers_path2, seekers_path3, seekers_path4;

function seekers_extends() { seekers_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return seekers_extends.apply(this, arguments); }



var SvgSeekers = function SvgSeekers(props) {
  return /*#__PURE__*/react.createElement("svg", seekers_extends({
    id: "seekers_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 646.59 646.59",
    style: {
      enableBackground: "new 0 0 646.59 646.59"
    },
    xmlSpace: "preserve"
  }, props), seekers_style || (seekers_style = /*#__PURE__*/react.createElement("style", null, ".seekers_svg__st1{fill:#00ff52}")), /*#__PURE__*/react.createElement("circle", {
    cx: 323.29,
    cy: 323.29,
    r: 323.29,
    style: {
      fill: "#262b33"
    }
  }), seekers_path || (seekers_path = /*#__PURE__*/react.createElement("path", {
    className: "seekers_svg__st1",
    d: "M310.57 406.69h-50.13c-26.82 0-47.05-17.88-47.05-41.6 0-23.94 20.19-42.69 45.96-42.69 24.01 0 35.6-2.6 59.07-13.27 5.56-2.53 11.16-6.15 17.64-10.34 19.75-12.78 44.34-28.69 90.02-28.69 60.63 0 150.81 73.25 154.62 76.36 4.27 3.5 4.9 9.8 1.4 14.07-3.5 4.27-9.79 4.91-14.07 1.41-.22-.18-22.63-18.44-51.62-36.42-37.39-23.18-68.62-35.43-90.33-35.43-39.78 0-60.7 13.54-79.16 25.48-6.85 4.43-13.32 8.62-20.23 11.76-26.02 11.83-40.49 15.06-67.34 15.06-14.56 0-25.96 9.97-25.96 22.69 0 12.52 11.38 21.6 27.05 21.6h50.13c21.68 0 38.3-17.36 38.47-17.54 3.78-4.01 10.1-4.22 14.12-.45 4.02 3.76 4.25 10.06.5 14.09-.9.99-22.55 23.91-53.09 23.91z"
  })), seekers_path2 || (seekers_path2 = /*#__PURE__*/react.createElement("path", {
    className: "seekers_svg__st1",
    d: "M300.76 497.14c-6.03 0-22.03 0-99.63-50.97-40.61-26.68-83.18-57.46-103.63-72.25-5.8-4.2-9.99-7.23-11.96-8.59-15.96-11.08-21.15-24.03-22.7-32.95-1.9-10.91.64-22.25 6.97-31.12 12.35-17.31 39.52-25.14 67.56-6.62 15.53 10.26 88.56 60.08 91.66 62.2 4.56 3.11 5.74 9.33 2.62 13.9-3.11 4.56-9.33 5.74-13.9 2.62-.76-.52-76.01-51.86-91.42-62.03-18.28-12.08-33.68-7.66-40.25 1.55-3.24 4.55-4.54 10.41-3.55 16.08 1.29 7.4 6.27 14.3 14.4 19.95 2.13 1.48 6.38 4.56 12.28 8.82 20.34 14.71 62.66 45.31 102.9 71.74 65.52 43.04 83.82 47.69 88.65 47.69 15.06 0 42.37-15.07 66.46-28.37 26.44-14.6 49.28-27.2 65.4-27.2 30.17 0 89.88 34.42 96.59 38.34 4.77 2.79 6.37 8.91 3.58 13.68s-8.91 6.37-13.68 3.58c-16.94-9.9-65.5-35.61-86.49-35.61-10.97 0-34.75 13.13-55.74 24.71-27.48 15.16-55.91 30.85-76.12 30.85z"
  })), seekers_path3 || (seekers_path3 = /*#__PURE__*/react.createElement("path", {
    className: "seekers_svg__st1",
    d: "M247.55 341.63c-1.97 0-3.96-.58-5.7-1.79-2.35-1.63-57.56-40.01-68.43-47.82-5.8-4.17-18.16-8.68-27.69.86-3.58 3.58-4.99 5.65-5.48 6.49-.54 3.85-3.31 7.2-7.31 8.27-5.33 1.44-10.82-1.72-12.26-7.06-1.6-5.96 1.76-12.7 10.9-21.85 7.66-7.66 17.35-11.64 28.06-11.49 8.91.12 17.94 3.15 25.44 8.54 10.74 7.72 67.6 47.24 68.17 47.64 4.54 3.15 5.66 9.38 2.5 13.92a9.952 9.952 0 0 1-8.2 4.29zm-107.54-46.21s0 .01 0 0c0 .01 0 0 0 0zm-.01-.01zm0-.02v.01-.01z"
  })), seekers_path4 || (seekers_path4 = /*#__PURE__*/react.createElement("path", {
    className: "seekers_svg__st1",
    d: "M306.17 331.72c-1.97 0-3.96-.58-5.7-1.79-2.35-1.63-57.56-40.01-68.43-47.82-5.8-4.17-18.16-8.68-27.69.86-3.58 3.58-4.99 5.65-5.49 6.49-.54 3.85-3.31 7.2-7.31 8.27-5.33 1.44-10.82-1.72-12.26-7.06-1.6-5.96 1.76-12.7 10.91-21.85 7.66-7.66 17.36-11.62 28.06-11.49 8.91.12 17.94 3.15 25.44 8.54 10.74 7.72 67.6 47.24 68.17 47.64 4.54 3.15 5.66 9.38 2.5 13.92-1.92 2.8-5.03 4.29-8.2 4.29zM198.63 285.5s0 .01 0 0c0 .01 0 0 0 0zm-.01-.02v.01c.01 0 .01 0 0-.01zM322.01 226.77h-.12a9.992 9.992 0 0 1-7.57-3.61l-51.3-61.71c-3.53-4.25-2.95-10.55 1.3-14.08 4.25-3.53 10.55-2.95 14.08 1.3l43.8 52.68 46.14-52.86c3.63-4.16 9.95-4.59 14.11-.96s4.59 9.95.96 14.11l-53.86 61.71c-1.9 2.17-4.65 3.42-7.54 3.42z"
  })));
};

/* harmony default export */ var seekers = (SvgSeekers);
;// CONCATENATED MODULE: ./src/features/content/assets/images/graphic-bg.svg?url
var graphic_bgurl_namespaceObject = "data:image/svg+xml;base64,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";
// EXTERNAL MODULE: ./src/features/content/components/breakdown-card/BreakdownCard.module.css
var BreakdownCard_module = __webpack_require__(73540);
var BreakdownCard_module_default = /*#__PURE__*/__webpack_require__.n(BreakdownCard_module);
;// CONCATENATED MODULE: ./src/features/content/components/breakdown-card/BreakdownCard.tsx


function BreakdownCard(param) {
    var title = param.title, subtitle = param.subtitle, Icon = param.icon, steps = param.steps;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative pt-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "absolute top-0 left-1/2 -translate-x-1/2 rounded-full bg-primary-green px-3 py-1 font-medium text-black",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col items-center gap-y-8 rounded-lg border border-off-white bg-white p-8 pt-12 shadow-card",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                        className: "h-32 w-32"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mb-auto whitespace-pre-line text-center",
                        children: subtitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
                        className: (BreakdownCard_module_default()).styledList,
                        children: steps
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/features/content/components/blocks/HowItWorksBlock.module.css
var HowItWorksBlock_module = __webpack_require__(57039);
var HowItWorksBlock_module_default = /*#__PURE__*/__webpack_require__.n(HowItWorksBlock_module);
;// CONCATENATED MODULE: ./src/features/content/components/blocks/HowItWorksBlock.tsx







function HowItWorksBlock() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "relative px-4 py-8 lg:py-12 ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute inset-0 -z-10 h-[864px] bg-cover bg-top bg-no-repeat",
                style: {
                    backgroundImage: "url(".concat(graphic_bgurl_namespaceObject, ")")
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "text-center text-4xl font-medium",
                children: "How it works"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mx-auto mt-2 max-w-prose text-center",
                children: "We've made it as easy as possible to connect people with the things they need. Whether you're an owner with stuff to rent out or a seeker looking to rent stuff, check out our 5 simple steps below."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Collapsible/* Collapsible */.zF, {
                className: "mt-4 flex flex-col items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapsible/* Collapsible.Trigger */.zF.Trigger, {
                        className: "p-2 text-center font-medium text-mid-green",
                        children: "Click to find out more \u2193"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Collapsible/* Collapsible.Content */.zF.Content, {
                        className: "".concat((HowItWorksBlock_module_default()).content, " mt-6 grid justify-center gap-8 px-4 lg:grid-cols-[repeat(2,374px)]"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BreakdownCard, {
                                title: "Item Owners",
                                subtitle: "Pumped to list your first item on Releaseit?\nHere's how.",
                                icon: owners,
                                steps: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "Hit 'List item'"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "Add your item details"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "Accept booking requests"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "Arrange pick-up & drop-off"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "font-medium",
                                            children: "Enjoy the extra cash \uD83D\uDCB8"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BreakdownCard, {
                                title: "Item Seekers",
                                subtitle: "Ready to rent with Releaseit?\nFollow these 5 easy steps.",
                                icon: seekers,
                                steps: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "Browse rentals"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "Request to book"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "Collect your rental"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            className: "font-medium",
                                            children: "Have an epic experience \uD83D\uDCA5"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: "Return it!"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./src/features/category/components/category-tile/CategoryTile.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




function CategoryTile(_param) {
    var name = _param.name, image = _param.image, href = _param.href, _variant = _param.variant, variant = _variant === void 0 ? "display" : _variant, className = _param.className, props = _objectWithoutProperties(_param, [
        "name",
        "image",
        "href",
        "variant",
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        prefetch: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", _objectSpread({}, props, {
            className: classnames_default()("relative mt-1 block overflow-hidden rounded-lg transition hover:-translate-y-1 hover:shadow-card", className),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: variant === "display" ? "aspect-w-3 aspect-h-2 sm:aspect-w-4 sm:aspect-h-3" : "aspect-w-1 aspect-h-1",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: image,
                        alt: name,
                        layout: "fill",
                        quality: 100,
                        objectFit: "cover",
                        objectPosition: "top",
                        placeholder: "blur"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/50 px-3 pb-2 pt-14",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "truncate text-xl font-medium text-white",
                        children: name
                    })
                })
            ]
        }))
    });
}

;// CONCATENATED MODULE: ./src/features/content/components/blocks/FeaturedCategoriesBlock.tsx
function FeaturedCategoriesBlock_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function FeaturedCategoriesBlock_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            FeaturedCategoriesBlock_defineProperty(target, key, source[key]);
        });
    }
    return target;
}



function FeaturedCategoriesBlock(param) {
    var categories = param.categories;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "container grid grid-cols-1 gap-3 sm:grid-cols-6 sm:gap-6 lg:gap-8",
        children: categories.map(function(category, idx) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryTile, FeaturedCategoriesBlock_objectSpread({}, category, {
                className: idx < 2 ? "sm:col-span-3" : "sm:col-span-2",
                onClick: function() {
                    return analytics/* analytics.trackEvent */.co.trackEvent("home.featured_categories", category);
                }
            }), category.href);
        })
    });
}

// EXTERNAL MODULE: ./src/assets/images/list-an-item-dt.webp
var list_an_item_dt = __webpack_require__(96959);
// EXTERNAL MODULE: ./src/assets/images/list-an-item-m.webp
var list_an_item_m = __webpack_require__(90865);
;// CONCATENATED MODULE: ./src/features/content/components/blocks/ListAnItemBlock.tsx





function ListAnItemBlock() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "container mt-8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/create-listing",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "hidden sm:block",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: list_an_item_dt/* default */.Z,
                        layout: "responsive",
                        className: "rounded-lg",
                        placeholder: "blur",
                        unoptimized: true,
                        alt: "list an item"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/create-listing",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "block sm:hidden",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: list_an_item_m/* default */.Z,
                        layout: "responsive",
                        className: "rounded-lg",
                        placeholder: "blur",
                        unoptimized: true,
                        alt: "list an item"
                    })
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/carousel-row/CarouselRow.tsx
var CarouselRow = __webpack_require__(87290);
;// CONCATENATED MODULE: ./src/features/content/components/blocks/CategoryRowsBlock.tsx
function CategoryRowsBlock_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CategoryRowsBlock_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CategoryRowsBlock_defineProperty(target, key, source[key]);
        });
    }
    return target;
}




function CategoryRowsBlock(param) {
    var categoryRows = param.categoryRows;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "container mt-8 space-y-8",
        children: categoryRows.map(function(row) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselRow/* CarouselRow */.O, {
                heading: row.heading,
                children: row.categories.map(function(category) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryTile, CategoryRowsBlock_objectSpread({}, category, {
                        variant: "square",
                        onClick: function() {
                            var normalisedHeading = row.heading.toLowerCase().replace(/\s/g, "_");
                            analytics/* analytics.trackEvent */.co.trackEvent("home.".concat(normalisedHeading), category);
                        }
                    }), category.href);
                })
            }, row.heading);
        })
    });
}

// EXTERNAL MODULE: ./src/generated/graphql.ts + 1 modules
var graphql = __webpack_require__(36998);
// EXTERNAL MODULE: ./src/features/listings/components/card/ListingCard.tsx + 2 modules
var ListingCard = __webpack_require__(33638);
// EXTERNAL MODULE: ./src/features/listings/helpers/map-listing-to-card.ts
var map_listing_to_card = __webpack_require__(19236);
;// CONCATENATED MODULE: ./src/features/content/components/blocks/RecommendationsBlock.tsx
function RecommendationsBlock_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function RecommendationsBlock_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            RecommendationsBlock_defineProperty(target, key, source[key]);
        });
    }
    return target;
}





var RECOMMENDATIONS_STALE_TIME = 5 * 60 * 1000; // 5 minutes
var HOME_PAGE_RECOMMENDATIONS_QUERY = "\n  query HomePageRecommendations {\n    HomePageRecommendations {\n      heading\n      listings {\n        ...ListingCardFragment\n      }\n    }\n  }\n";
function RecommendationsBlock() {
    var ref = (0,graphql/* useHomePageRecommendationsQuery */.Uo)(undefined, {
        staleTime: RECOMMENDATIONS_STALE_TIME,
        useErrorBoundary: true,
        select: function(data) {
            return data.HomePageRecommendations;
        }
    }), sections = ref.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "container mt-8 mb-12 space-y-8",
        children: sections === null || sections === void 0 ? void 0 : sections.map(function(section) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselRow/* CarouselRow */.O, {
                heading: section.heading,
                children: section.listings.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListingCard/* ListingCard */.d, RecommendationsBlock_objectSpread({}, (0,map_listing_to_card/* mapListingToCard */.B)(item), {
                        className: "h-full",
                        onClick: function() {
                            var normalisedHeading = section.heading.toLowerCase().replace(/\s/g, "_");
                            analytics/* analytics.trackEvent */.co.trackEvent("home.".concat(normalisedHeading), {
                                listingId: item.listingId,
                                title: item.title
                            });
                        }
                    }), item.listingId);
                })
            }, section.heading);
        })
    });
}
function ErrorFallback() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "container mt-16",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "rounded-md border border-error bg-error/5 p-16 text-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-xl font-medium leading-loose",
                    children: "Something went wrong"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-gray-800",
                    children: "Unable to fetch latest recommendations"
                })
            ]
        })
    });
}
RecommendationsBlock.ErrorFallback = ErrorFallback;

// EXTERNAL MODULE: ./src/features/content/hooks/use-newsletter-dialog.ts
var use_newsletter_dialog = __webpack_require__(59832);
;// CONCATENATED MODULE: ./src/pages/index.tsx





var NewsletterDialog = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5891), __webpack_require__.e(3603), __webpack_require__.e(5855), __webpack_require__.e(7478), __webpack_require__.e(7038), __webpack_require__.e(7183)]).then(__webpack_require__.bind(__webpack_require__, 97183));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(97183)
            ];
        }
    },
    ssr: false
});
var HomePage = function(param) {
    var bannerImages = param.bannerImages, featuredCategories = param.featuredCategories, categoryRows = param.categoryRows, featuredInLogos = param.featuredInLogos;
    var hasSeenDialog = (0,use_newsletter_dialog/* useNewsletterDialog */.P)().hasSeenDialog;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Seo/* Seo */.p, {}),
            !hasSeenDialog && /*#__PURE__*/ (0,jsx_runtime.jsx)(NewsletterDialog, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBlock, {
                bannerImages: bannerImages
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedInBlock, {
                logos: featuredInLogos
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HowItWorksBlock, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedCategoriesBlock, {
                categories: featuredCategories
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListAnItemBlock, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryRowsBlock, {
                categoryRows: categoryRows
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_error_boundary_umd.ErrorBoundary, {
                FallbackComponent: RecommendationsBlock.ErrorFallback,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RecommendationsBlock, {})
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var pages = (HomePage);


/***/ }),

/***/ 46348:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "zF": function() { return /* binding */ Collapsible; }
/* harmony export */ });
/* unused harmony exports CollapsibleTrigger, CollapsibleContent */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _radix_ui_react_collapsible__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71206);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectSpread(target) {
    var _arguments = arguments, _loop = function(i) {
        var source = _arguments[i] != null ? _arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    };
    for(var i = 1; i < arguments.length; i++)_loop(i);
    return target;
}
function Collapsible(_param) {
    var props = _extends({}, _param);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_collapsible__WEBPACK_IMPORTED_MODULE_1__/* .Root */ .fC, _objectSpread({}, props));
}
var CollapsibleTrigger = _radix_ui_react_collapsible__WEBPACK_IMPORTED_MODULE_1__/* .Trigger */ .xz;
var CollapsibleContent = _radix_ui_react_collapsible__WEBPACK_IMPORTED_MODULE_1__/* .Content */ .VY;
Collapsible.Trigger = CollapsibleTrigger;
Collapsible.Content = CollapsibleContent;


/***/ }),

/***/ 57039:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"content":"HowItWorksBlock_content__H4hjh","open":"HowItWorksBlock_open__80uNf","close":"HowItWorksBlock_close__NH5zN"};

/***/ }),

/***/ 73540:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"styledList":"BreakdownCard_styledList__BrVbK"};

/***/ }),

/***/ 80589:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(exports, __webpack_require__(2784)) :
  0;
})(this, (function (exports, React) { 'use strict';

  function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
      Object.keys(e).forEach(function (k) {
        if (k !== 'default') {
          var d = Object.getOwnPropertyDescriptor(e, k);
          Object.defineProperty(n, k, d.get ? d : {
            enumerable: true,
            get: function () { return e[k]; }
          });
        }
      });
    }
    n["default"] = e;
    return Object.freeze(n);
  }

  var React__namespace = /*#__PURE__*/_interopNamespace(React);

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
  }

  var changedArray = function changedArray(a, b) {
    if (a === void 0) {
      a = [];
    }

    if (b === void 0) {
      b = [];
    }

    return a.length !== b.length || a.some(function (item, index) {
      return !Object.is(item, b[index]);
    });
  };

  var initialState = {
    error: null
  };

  var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
    _inheritsLoose(ErrorBoundary, _React$Component);

    function ErrorBoundary() {
      var _this;

      for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
        _args[_key] = arguments[_key];
      }

      _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;
      _this.state = initialState;

      _this.resetErrorBoundary = function () {
        var _this$props;

        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        _this.props.onReset == null ? void 0 : (_this$props = _this.props).onReset.apply(_this$props, args);

        _this.reset();
      };

      return _this;
    }

    ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
      return {
        error: error
      };
    };

    var _proto = ErrorBoundary.prototype;

    _proto.reset = function reset() {
      this.setState(initialState);
    };

    _proto.componentDidCatch = function componentDidCatch(error, info) {
      var _this$props$onError, _this$props2;

      (_this$props$onError = (_this$props2 = this.props).onError) == null ? void 0 : _this$props$onError.call(_this$props2, error, info);
    };

    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
      var error = this.state.error;
      var resetKeys = this.props.resetKeys; // There's an edge case where if the thing that triggered the error
      // happens to *also* be in the resetKeys array, we'd end up resetting
      // the error boundary immediately. This would likely trigger a second
      // error to be thrown.
      // So we make sure that we don't check the resetKeys on the first call
      // of cDU after the error is set

      if (error !== null && prevState.error !== null && changedArray(prevProps.resetKeys, resetKeys)) {
        var _this$props$onResetKe, _this$props3;

        (_this$props$onResetKe = (_this$props3 = this.props).onResetKeysChange) == null ? void 0 : _this$props$onResetKe.call(_this$props3, prevProps.resetKeys, resetKeys);
        this.reset();
      }
    };

    _proto.render = function render() {
      var error = this.state.error;
      var _this$props4 = this.props,
          fallbackRender = _this$props4.fallbackRender,
          FallbackComponent = _this$props4.FallbackComponent,
          fallback = _this$props4.fallback;

      if (error !== null) {
        var _props = {
          error: error,
          resetErrorBoundary: this.resetErrorBoundary
        };

        if ( /*#__PURE__*/React__namespace.isValidElement(fallback)) {
          return fallback;
        } else if (typeof fallbackRender === 'function') {
          return fallbackRender(_props);
        } else if (FallbackComponent) {
          return /*#__PURE__*/React__namespace.createElement(FallbackComponent, _props);
        } else {
          throw new Error('react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop');
        }
      }

      return this.props.children;
    };

    return ErrorBoundary;
  }(React__namespace.Component);

  function withErrorBoundary(Component, errorBoundaryProps) {
    var Wrapped = function Wrapped(props) {
      return /*#__PURE__*/React__namespace.createElement(ErrorBoundary, errorBoundaryProps, /*#__PURE__*/React__namespace.createElement(Component, props));
    }; // Format for display in DevTools


    var name = Component.displayName || Component.name || 'Unknown';
    Wrapped.displayName = "withErrorBoundary(" + name + ")";
    return Wrapped;
  }

  function useErrorHandler(givenError) {
    var _React$useState = React__namespace.useState(null),
        error = _React$useState[0],
        setError = _React$useState[1];

    if (givenError != null) throw givenError;
    if (error != null) throw error;
    return setError;
  }
  /*
  eslint
    @typescript-eslint/sort-type-union-intersection-members: "off",
    @typescript-eslint/no-throw-literal: "off",
    @typescript-eslint/prefer-nullish-coalescing: "off"
  */

  exports.ErrorBoundary = ErrorBoundary;
  exports.useErrorHandler = useErrorHandler;
  exports.withErrorBoundary = withErrorBoundary;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
//# sourceMappingURL=react-error-boundary.umd.js.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7164,9097,6577,2066,3848,736,6998,9056,9774,2888,179], function() { return __webpack_exec__(87314); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);